import axios from 'axios';

export default {
  namespaced: true,
  state: {

  },
  mutations: {
  },
  actions: {
    addQrcode({ commit }, params) {
      return axios.post('/wxnews/ajax/addQrcode', params)
        .then((data) => {
          return data;
        });
    },
    searchWxQrcodes({ commit }, params) {
      return axios.get('/wxnews/ajax/searchWxQrcodes', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    updateQrcode({ commit }, params) {
      return axios.post('/wxnews/ajax/updateQrcode', params)
        .then((data) => {
          return data;
        });
    },
    exportQrcodeList({ commit }, params) {
      return axios.get('/wxnews/ajax/exportQrcodeList', {
        params: params
      },
      { responseType: 'blob' }).then((data) => {
        return data;
      });
    },
    downloadQrcode({ commit }, params) {
      return axios.get('/wxnews/ajax/downloadQrcode', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    getQrcodeDetial({ commit }, params) {
      return axios.get('/wxnews/ajax/getQrcodeDetial', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    getComunityList({ commit }, params) {
      return axios.get('/wxnews/ajax/getComunityList', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    searchQrcodeFans({ commit }, params) {
      return axios.get('/wxnews/ajax/searchQrcodeFans', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    mergePic({ commit }, params) {
      return axios.get('/wxnews/ajax/mergePic', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    synchCreateCommunityQrcode({ commit }, params) {
      return axios.get('/wxnews/ajax/synchCreateCommunityQrcode', {
        params: params,
      }).then((data) => {
        return data;
      });
    }
  },
};
